export const LOCAL_STORAGE_TOKEN_NAME = 'myblog';
